/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/
//flow
//
import _ from 'lodash';
import React, { Component } from 'react';
import { Page, TextStyle, Banner } from '@shopify/polaris';
import { connect } from 'react-redux';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { routes } from 'src/routes';
import history from 'src/routes/history';
import SendRequestModal from 'src/components/containers/common/send-request-modal';

type Props = {
  emailSupport: string
};

type ComposedProps = Props & WithI18nProps & FormProps;

type State = {
  activeRequest: boolean
};

class LayoutSwitchSuccess extends Component<ComposedProps, State> {
  state = {
    activeRequest: false
  };

  render() {
    const { i18n, emailSupport } = this.props;
    return (
      <div className="BC-Page BC-Page_Success">
        <Page
          title={i18n.translate('AdminHTML.SwitchLayout.SwitchLayout.title')}
          breadcrumbs={[
            {
              content: i18n.translate('AdminHTML.SwitchLayout.SwitchLayout.title'),
              onAction: this.backToLayoutSwitch
            }
          ]}>
          <Banner
            title={i18n.translate('AdminHTML.SwitchLayout.LayoutSwitchSuccess.title')}
            status="success"
            action={{
              content: i18n.translate('AdminHTML.Common.Action.goHome'),
              onAction: this.goToHomepage
            }}
            secondaryAction={{
              content: i18n.translate('AdminHTML.Common.Action.sendRequest'),
              onAction: this.sendRequest
            }}>
            <TextStyle>
              {i18n.translate('AdminHTML.SwitchLayout.LayoutSwitchSuccess.content', {
                nt_email: <TextStyle variation="strong">{emailSupport}</TextStyle>
              })}
            </TextStyle>
          </Banner>
          <SendRequestModal
            active={this.state.activeRequest}
            handleChange={() => this.toggleChangeState('activeRequest')}
          />
        </Page>
      </div>
    );
  }

  // Open link: switch layout
  backToLayoutSwitch = () => {
    history.push(routes.switchLayout.view());
  };

  // Open link: homepage
  goToHomepage = () => {
    history.push(routes.dashboard.view());
  };

  // Toggle change state
  toggleChangeState = (id: string) => {
    const value = this.state[id];
    this.setState({ [id]: !value });
  };

  // send Request
  sendRequest = () => {
    this.toggleChangeState('activeRequest');
  };
}

const mapStateToProps = (state, props) => ({
  emailSupport: _.get(state.oauth, 'emailSupport')
});

export default connect(mapStateToProps, {})(withI18n()(LayoutSwitchSuccess));
